import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

import { cn } from '../../lib/cn';

interface EmptyStateProps {
  icon: LucideIcon;
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
  className?: string;
}

/**
 * Centered empty-state block. Icon (32px muted) + Title (17px) + Body copy
 * + one action. No illustrations, no mascots — cockpit-language.
 */
export function EmptyState({ icon: Icon, title, description, action, className }: EmptyStateProps): JSX.Element {
  return (
    <div className={cn('mx-auto grid max-w-[320px] place-items-center px-4 py-12 text-center', className)}>
      <Icon className="mb-3 size-8 text-ink-faint" strokeWidth={1.5} aria-hidden />
      <h3 className="text-[17px] font-medium leading-tight tracking-tight text-ink">{title}</h3>
      {description ? (
        <p className="mt-1.5 text-sm text-ink-muted [text-wrap:pretty]">{description}</p>
      ) : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  );
}
